import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
  toYesNo,
} from "./principle6SheetHelpers";
import {
  filterPopulatedRows,
  formatExcelDate,
  setStandardDetailWidths,
} from "./principle8SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Details of SIA";

const SHEET_TITLE =
  "Details of Social Impact Assessments (SIA) of projects undertaken by the entity based on applicable laws, in the current financial year.";

export function buildDetailsOfSIASheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setStandardDetailWidths(ws, { D: 8, E: 24, F: 16, G: 14, H: 22, I: 22, J: 18 });

  const rows = filterPopulatedRows(
    sectionC?.principle8?.essentialIndicators?.socialImpactAssessments,
    [
      "projectName",
      "SIANotificationNo",
      "dateOfNotification",
      "conductedByExternalAgency",
      "resultsCommunicatedPublicDomain",
      "webLink",
    ]
  );

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, { mergeEnd: COL_J });

  mergeRow(ws, TITLE_ROW, COL_D, COL_J, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Name and brief details of project", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_F, "SIA Notification No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, "Date of notification", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_H, "Whether conducted by independent external agency", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_I, "Results communicated in public domain", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_J, "Relevant Web link", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.projectName), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.SIANotificationNo), { align: "left" });
    setCell(ws, row, COL_G, formatExcelDate(item?.dateOfNotification), { align: "center" });
    setCell(ws, row, COL_H, toYesNo(item?.conductedByExternalAgency), { align: "center" });
    setCell(ws, row, COL_I, toYesNo(item?.resultsCommunicatedPublicDomain), { align: "center" });
    setCell(ws, row, COL_J, safeText(item?.webLink, ""), { align: "left" });
  });

  return ws;
}
